import React, { useEffect, useState, Fragment } from "react";
import Breadcrumb from "../../DefaultComponent/BreadCrumb";
import {
  PaymentPlanCreateAction,
  PaymentPlanCreateDiscountAction,
  PaymentPlanListAction,
  PaymentPlanUpdateDiscountAction,
  UpdatePlanAction,
  // PaymentPlanCreateDiscountAction,
  // PaymentPlanUpdateDiscountAction,
} from "../../../Redux/Actions/PaymentAction";
import {
  Button,
  ToggleButton,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  IconButton,
  Stack,
  Pagination,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Spinner from "../../DefaultComponent/Spinner";
import ToastDefault from "../../DefaultComponent/Toast";
import SelectOption from "../../DefaultComponent/FilterHelper/SelectOption";
import { calculateTotalPages, formatDate } from "../../../utils/Helper";
import { StyledToggleButtonGroup } from "../../DefaultComponent/FilterHelper/Tooglebutton";
import CreatePlan, { PaymentPlan } from "./CreatePlan";
import UpdatePlan from "./UpdatePlan/UpdatePlan";
import { useDispatch, useSelector } from "react-redux";
import CreatePlanDiscount from "./PlanDiscount/CreatePlanDiscount/CreatePlanDiscount";
import UpdatePlanDiscount from "./PlanDiscount/UpdatePlanDiscount/UpdatePlanDiscount";

const PaymentPlanTypeOptions = [
  { label: "User", value: "USER" },
  { label: "Organization", value: "ORGANIZATION" },
];

const Plans: React.FC = () => {
  const dispatch = useDispatch<any>();
  const PlanListData = useSelector((state: any) => state.PaymentPlansListData);

  const [plansList, setPlansList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;

  const [planType, setPlanType] = useState("USER");
  const [durationType, setDurationType] = useState("MONTHLY");

  const [openCreatePlan, setOpenCreatePlan] = useState(false);
  const [openEditPlan, setOpenEditPlan] = useState(false);
  const [planForEdit, setPlanForEdit] = useState<number | null>(null);
  const [planForDiscount, setPlanForDiscount] = useState<number | null>(null);

  const [openCreateDiscount, setOpenCreateDiscount] = useState(false);
  const [openEditDiscount, setOpenEditDiscount] = useState(false);
  const [planDiscountId, setPlanDiscountId] = useState<number | null>(null);

  useEffect(() => {
    fetchPlans();
  }, [planType, durationType]);

  useEffect(() => {
    if (PlanListData?.data?.row) {
      setPlansList(PlanListData.data.row);
      setLoading(false);
    }
  }, [PlanListData]);

  const fetchPlans = () => {
    setLoading(true);
    dispatch(
      PaymentPlanListAction(
        `?page=${page}&page_size=${rowsPerPage}&plan_type=${planType}&duration_type=${durationType}`
      )
    );
  };

  const handleCreatePlan = (data: PaymentPlan) => {
    dispatch(PaymentPlanCreateAction(data)).then(() => {
      fetchPlans();
      setOpenCreatePlan(false);
    });
  };

  const handleEditPlan = (payload: any, params: string) => {
    dispatch(UpdatePlanAction(payload, params)).then(() => {
      fetchPlans();
      setOpenEditPlan(false);
    });
  };

  const handleCreateDiscount = (data: any) => {
    dispatch(PaymentPlanCreateDiscountAction(data)).then(() => {
      setOpenCreateDiscount(false);
      fetchPlans();
    });
  };

  const handleEditDiscount = (data: any, params: string) => {
    dispatch(PaymentPlanUpdateDiscountAction(data, params)).then(() => {
      setOpenEditDiscount(false);
      fetchPlans();
    });
  };

  return (
    <>
      {loading && <Spinner />}
      <div
        className="page-wrapper card"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <Box sx={{ p: 2 }}>
          <Breadcrumb
            pageTitle="Payment Plans"
            breadcrumbs={[
              {
                label: "Payment Plans",
                path: "/payment-plans",
                isActive: true,
              },
            ]}
          />
        </Box>
        <Box
          sx={{
            m: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>
            <StyledToggleButtonGroup
              color="primary"
              value={durationType}
              exclusive
              onChange={(_: any, val: any) => setDurationType(val || "")}
              aria-label="Duration Type"
            >
              <ToggleButton value="MONTHLY">Monthly</ToggleButton>
              <ToggleButton value="QUARTERLY">Quarterly</ToggleButton>
              <ToggleButton value="ANNUAL">Annual</ToggleButton>
            </StyledToggleButtonGroup>

            <SelectOption
              option={PaymentPlanTypeOptions}
              select={planType}
              setSelect={setPlanType}
              setPage={setPage}
            />
          </Box>

          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenCreatePlan(true)}
          >
            Create Plan
          </Button>
        </Box>

        <Box sx={{ m: 2 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ backgroundColor: "#0555c8" }}>
                <TableRow>
                  {[
                    "S.No",
                    "Plan Name",
                    "Description",
                    "Type",
                    "Duration",
                    "Duration Type",
                    "Price",
                    "Credits",
                    "Discount",
                    "Created At",
                    "Features",
                    "",
                  ].map((h) => (
                    <TableCell key={h} align="center" sx={{ color: "white" }}>
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {plansList.length > 0 ? (
                  plansList.map((plan, idx) => (
                    <TableRow key={plan.id} hover>
                      <TableCell align="center">{idx + 1}</TableCell>
                      <TableCell align="center">{plan.name}</TableCell>
                      <TableCell align="center">{plan.description}</TableCell>
                      <TableCell align="center">{plan.type}</TableCell>
                      <TableCell align="center">{plan.duration}</TableCell>
                      <TableCell align="center">{plan.duration_type}</TableCell>
                      <TableCell align="center">
                        {plan.price.toFixed(2)}
                      </TableCell>
                      <TableCell align="center">{plan.credits}</TableCell>

                      <TableCell align="center">
                        {plan.discount ? (
                          <Fragment>
                            <Tooltip
                              title={`On ${plan.discount.discount_on} • ${
                                plan.discount.discount_type
                              } ${plan.discount.discount_value}${
                                plan.discount.discount_type === "PERCENTAGE"
                                  ? "%"
                                  : ""
                              }`}
                              arrow
                            >
                              <span>
                                {plan.discount.discount_value}{" "}
                                {plan.discount.discount_type}
                              </span>
                            </Tooltip>

                            <IconButton
                              size="small"
                              sx={{ ml: 1 }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setPlanDiscountId(plan?.discount?.id);
                                setOpenEditDiscount(true);
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Fragment>
                        ) : (
                          <>
                            {plan.category === "FREE" ? (
                              "N/A"
                            ) : (
                              <Button
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setPlanForDiscount(plan.id);
                                  setOpenCreateDiscount(true);
                                }}
                              >
                                Create Discount
                              </Button>
                            )}
                          </>
                        )}
                      </TableCell>

                      <TableCell align="center">
                        {formatDate(plan.created_at)}
                      </TableCell>

                      <TableCell>
                        {plan.features?.length > 0 ? (
                          <ul style={{ margin: 0, paddingLeft: "1rem" }}>
                            {plan.features.map((f: any, i: number) => (
                              <li key={i} style={{ fontSize: "0.875rem" }}>
                                {f.feature}{" "}
                                {f.is_included ? "(Included)" : "(Excluded)"}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          "N/A"
                        )}
                      </TableCell>

                      <TableCell align="center">
                        <IconButton
                          onClick={() => {
                            setPlanForEdit(plan?.id);
                            setOpenEditPlan(true);
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={12} align="center">
                      No Payment Plans Found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box sx={{ m: 2, display: "flex", justifyContent: "center" }}>
          <Stack spacing={2}>
            <Pagination
              count={calculateTotalPages(
                PlanListData?.data?.total_count || 0,
                rowsPerPage
              )}
              page={page}
              onChange={(_, p) => setPage(p)}
              color="primary"
              variant="outlined"
              shape="rounded"
            />
          </Stack>
        </Box>

        <ToastDefault />
      </div>
      <CreatePlan
        open={openCreatePlan}
        onClose={() => setOpenCreatePlan(false)}
        onSubmit={handleCreatePlan}
      />

      {planForEdit != null && (
        <UpdatePlan
          open={openEditPlan}
          onClose={() => setOpenEditPlan(false)}
          onSubmit={handleEditPlan}
          planId={planForEdit}
        />
      )}

      {planForDiscount != null && (
        <CreatePlanDiscount
          open={openCreateDiscount}
          onClose={() => setOpenCreateDiscount(false)}
          onSubmit={handleCreateDiscount}
          planId={planForDiscount}
        />
      )}

      {planDiscountId != null && (
        <UpdatePlanDiscount
          open={openEditDiscount}
          onClose={() => {
            setOpenEditDiscount(false);
            setPlanDiscountId(null);
          }}
          onSubmit={handleEditDiscount}
          discountId={planDiscountId}
          initialData={
            plansList.find((p) => p?.discount?.id === planDiscountId)
              ?.discount || {}
          }
        />
      )}
    </>
  );
};

export default Plans;
